import Grid from "@mui/material/Grid";
import { styled as styling } from "@mui/material/styles";
import Color from "../../../assets/colors";

export const Wrapper = styling(Grid)({
  backgroundColor: Color.backgroundGrey,
  display: "flex",
  position: "relative",
  flexDirection: "column",
  minHeight: "100svh",
  alignItems: "flex-start",
});
